import React from 'react';
import { CellParamsDef } from '@grnhse/seedling/lib/birch/components/table';
import TagsCell from 'talent_matching/components/shared/tags_cell';
import BaseCandidateCell from 'talent_matching/components/shared/base_candidate_cell';
import LatestApplicationHistoryCell from 'talent_matching/talent_rediscovery/components/table/latest_application_history_cell'; // eslint-disable-line max-len
import RediscoveryRowActions from 'talent_matching/talent_rediscovery/components/table/rediscovery_row_actions';
import { useRediscoveryApplication } from 'talent_matching/talent_rediscovery/hooks/use_rediscovery_applications';
import { withLocalePrefix } from 'shared/utils/translation';
import { ACTIONS_COLUMN_FIELD } from 'talent_matching/hooks/use_column_visibility';

const t = withLocalePrefix('talent_matching.rediscovery.table.columns');

type ColumnsOptions = {
  userDateFormat: string;
};

const RediscoveryTagsCell = ({ applicationId }: { applicationId: number }) => {
  const { application } = useRediscoveryApplication(applicationId);

  return <TagsCell tags={application?.tags} />;
};

const CandidateCellWithData = ({
  applicationId,
}: {
  applicationId: number;
}) => {
  const { application } = useRediscoveryApplication(applicationId);

  if (!application) {
    return null;
  }

  return <BaseCandidateCell candidate={application} />;
};

const ApplicationHistoryCellWithData = ({
  applicationId,
  userDateFormat,
}: {
  applicationId: number;
  userDateFormat: string;
}) => {
  const { application } = useRediscoveryApplication(applicationId);

  if (!application) {
    return null;
  }

  return (
    <LatestApplicationHistoryCell
      application={application}
      userDateFormat={userDateFormat}
    />
  );
};

export const useRediscoveryColumns = ({ userDateFormat }: ColumnsOptions) => {
  return [
    {
      field: 'fullName',
      headerName: t('candidate'),
      minWidth: 250,
      cell: (params: CellParamsDef) => {
        return <CandidateCellWithData applicationId={params.row.id} />;
      },
    },
    {
      field: 'latestApplicationHistory',
      headerName: t('latest_application_history'),
      minWidth: 250,
      cell: (params: CellParamsDef) => {
        return (
          <ApplicationHistoryCellWithData
            applicationId={params.row.id}
            userDateFormat={userDateFormat}
          />
        );
      },
    },
    {
      field: 'tags',
      headerName: t('tags'),
      minWidth: 200,
      cell: (params: CellParamsDef) => {
        return <RediscoveryTagsCell applicationId={params.row.id} />;
      },
    },
    {
      field: ACTIONS_COLUMN_FIELD,
      headerName: '',
      width: 60,
      sortable: false,
      resizable: false,
      disableColumnMenu: true,
      cell: (params: CellParamsDef) => {
        return <RediscoveryRowActions applicationId={params.row.id} />;
      },
    },
  ];
};
